// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Grid, A11y } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import "swiper/css/grid";
import 'swiper/css/pagination';

window.InitSlider = function (selector, modifiedOptions) {
    if (document.querySelectorAll(selector).length) {
        document.querySelectorAll(selector).forEach((elem) => {
            let options = {
                // configure Swiper to use modules
                keyboard: {
                    enabled: true
                },
                modules: [Autoplay, Navigation, Pagination, Grid, A11y],
                navigation: {
                    nextEl: elem.querySelector('.swiper-button-next'),
                    prevEl: elem.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: elem.querySelector('.swiper-pagination-progress'),
                    type: "fraction",
                },
                scrollOnFocus: true,
                slidesPerView: 1.1,
                spaceBetween: 28,
                breakpoints: {
                    640: {
                        slidesPerView: 2
                    },
                    1024: {
                        spaceBetween: 32,
                        slidesPerView: 3
                    }
                },
                a11y: true
            };
            Object.assign(options, modifiedOptions);
            const swiper = new Swiper(elem, options);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    window.InitSlider('.brands__swiper.swiper', {
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            560: {
                slidesPerView: 'auto',
                spaceBetween: 100
            }
        },
        direction: 'horizontal',
        slidesPerView: 'auto'
    });
    window.InitSlider('.clickblocks__blocks--slider-default');
    window.InitSlider('.clickblocks__blocks--slider-images', {
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 32
            }
        }
    });
    window.InitSlider('.album.album--slideshow .album__items.swiper', {
        slidesPerView: 1,
        breakpoints: {}
    });
    window.InitSlider('.imageslideshow.swiper', {
        slidesPerView: 1,
        breakpoints: {}
    });
    window.InitSlider('.services-promo__slider--tall', {
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            1024: {
                spaceBetween: 32,
                slidesPerView: 3
            },
            1280: {
                spaceBetween: 32,
                slidesPerView: 4
            }
        },
    });
    window.InitSlider('.services-promo__slider');
    window.InitSlider('.projectslider__slider.swiper');
    window.InitSlider('.reviews__swiper');
    window.InitSlider('.steps__slider');
    window.InitSlider('.videos__slider');
    window.InitSlider('.basicblock__slider', {
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 32
            },
            1440: {
                slidesPerView: 2.25
            },
            1920: {
                slidesPerView: 2.5
            },
            2560: {
                slidesPerView: 3
            }
        }
    });
    window.InitSlider('.team__slideshow');
});
